import { useMemo } from 'react';

import { useFormikContext } from 'formik';

import { earliestStartDate } from './earliestStart';

/** The earliest start the staged predecessors allow. Masked predecessors are not staged in the form, but they still constrain the start. */
const useEarliestStart = (maskedPredecessors) => {
    const { values } = useFormikContext();

    return useMemo(() => earliestStartDate([...(values.dependencies || []), ...maskedPredecessors]), [values.dependencies, maskedPredecessors]);
};

export default useEarliestStart;
